import { createEntitySchemas } from '../../../utils/normalize'

import { userPublicDataSchemas } from './publicData'

export const USER = 'users'
export const userSchemas = createEntitySchemas(USER, {
  definitions: {
    public_data: userPublicDataSchemas.entity
  }
})
